// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { BackgroundCheck } from './background-check';
import { CommitteeMember } from './committee-member';
import { Family } from './family';
import { GroupPerson } from './group-person';
import { InterestSurvey } from './interest-survey';
import { Involvement } from './involvement';
import { PersonInterest } from './person-interest';
import { PersonStatus } from './person-status';
import { Relationship } from './relationship';
import { School } from './school';

/// <code-import> Place custom imports between <code-import> tags
import { UtilityService } from '../core.module';
import moment from 'moment';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Person extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get birthDateLocal() {
        return UtilityService.utcToLocal(this.birthDate, true);
    }
    set birthDateLocal(value) {
        this.birthDate = UtilityService.localToUtc(value);
    }

    get baptizedDateLocal() {
        return UtilityService.utcToLocal(this.baptizedDate, true);
    }
    set baptizedDateLocal(value) {
        this.baptizedDate = UtilityService.localToUtc(value);
    }

    get professionDateLocal() {
        return UtilityService.utcToLocal(this.professionDate, true);
    }
    set professionDateLocal(value) {
        this.professionDate = UtilityService.localToUtc(value);
    }

    get joinedDateLocal() {
        return UtilityService.utcToLocal(this.joinedDate, true);
    }
    set joinedDateLocal(value) {
        this.joinedDate = UtilityService.localToUtc(value);
    }

    get graduationDateLocal() {
        return UtilityService.utcToLocal(this.graduationDate, true);
    }
    set graduationDateLocal(value) {
        this.graduationDate = UtilityService.localToUtc(value);
    }

    get weddingDateLocal() {
        return UtilityService.utcToLocal(this.weddingDate, true);
    }
    set weddingDateLocal(value) {
        this.weddingDate = UtilityService.localToUtc(value);
    }
    get deceasedDateLocal() {
        return UtilityService.utcToLocal(this.deceasedDate, true);
    }
    set deceasedDateLocal(value) {
        this.deceasedDate = UtilityService.localToUtc(value);
    }
    get departureDateLocal() {
        return UtilityService.utcToLocal(this.departureDate, true);
    }
    set departureDateLocal(value) {
        this.departureDate = UtilityService.localToUtc(value);
    }

    get lastSafeChurchTrainedLocal() {
        return UtilityService.utcToLocal(this.lastSafeChurchTrained, true);
    }
    set lastSafeChurchTrainedLocal(value) {
        this.lastSafeChurchTrained = UtilityService.localToUtc(value);
    }

    get displayName() {
        return `${this.firstName || ''} ${this.lastName || ''}`;
    }

    get displayNameLastFirst() {
        return `${this.lastName + ',' || ''} ${this.firstName || ''}`;
    }

    get displayAddress() {
        const address = this.useFamilyAddress
            ? this.family && this.family.displayAddress
            : `${this.address1 || ''} ${this.address2 || ''} ${this.city || ''} ${this.state || ''} ${this.zip || ''}`;
        return address;
    }

    get age() {
        if (!this.birthDate) return null;
        return moment().diff(moment(this.birthDate), 'year');
    }

    getPersonInfo() {
        return {
            name: this.firstName + ' ' + this.lastName + (this.envelopeNumber ? ' - ' + this.envelopeNumber : ''),
            id: this.id,
            envelope: this.envelopeNumber,
            sex: this.sex,
        };
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  address1?: string;
  address2?: string;
  baptizedDate?: Date;
  birthDate?: Date;
  cellPhone?: string;
  city?: string;
  code?: string;
  country?: string;
  created!: Date;
  createdBy?: string;
  deceasedDate?: Date;
  departureDate?: Date;
  donorId?: number;
  email?: string;
  employer?: string;
  envelopeNumber?: string;
  familyId?: number;
  father?: string;
  firstName?: string;
  grade?: string;
  graduationDate?: Date;
  homePhone?: string;
  howJoined?: string;
  includeForGiving!: boolean;
  includeInDirectory!: boolean;
  interestsLastUpdated?: Date;
  isActive!: boolean;
  isBaptized!: boolean;
  isCellPhoneUnlisted!: boolean;
  isEmailUnlisted!: boolean;
  isHomePhoneUnlisted!: boolean;
  isProfessing!: boolean;
  isWorkPhoneUnlisted!: boolean;
  jobCodeId?: number;
  joinedDate?: Date;
  lastAccountAccess?: Date;
  lastName?: string;
  lastSafeChurchTrained?: Date;
  maritalStatusId?: number;
  memberDate?: Date;
  middleName?: string;
  mother?: string;
  note?: string;
  oldPersonId?: string;
  personStatusId?: number;
  preferredName?: string;
  previousChurch?: string;
  professionDate?: Date;
  relationshipId?: number;
  schoolId?: number;
  sex?: string;
  state?: string;
  suffix?: string;
  title?: string;
  undefined6?: string;
  undefined7?: string;
  undefined8?: string;
  undefinedDT10?: string;
  undefinedPhone1?: string;
  undefinedPhone2?: string;
  undefinedPhone3?: string;
  updated!: Date;
  updatedBy?: string;
  useFamilyAddress!: boolean;
  useFamilyHomePhone!: boolean;
  weddingDate?: Date;
  workExt?: string;
  workPhone?: string;
  zip?: string;
  backgroundChecks!: BackgroundCheck[];
  committeeMembers!: CommitteeMember[];
  family!: Family;
  groupPersons!: GroupPerson[];
  interestSurveys!: InterestSurvey[];
  involvements!: Involvement[];
  personInterests!: PersonInterest[];
  personStatus!: PersonStatus;
  relationship!: Relationship;
  school!: School;
}

